export default __webpack_public_path__ + "static/media/Food_header.425b5d32.jpg";